import React from 'react'
import { flatten } from 'lodash'
import CheckedMultiSelector from '../checked-multi-selector'
import LabeledInput from '../labeled-input'
import { ClockFill } from 'react-bootstrap-icons'
import useHours from '../../../hooks/use-hours'

const ClassHoursMultiSelector = ({
    values = [],
    onChange = () => {},
    disabled,
    showIcon,
    label = 'Class Hour'
}) => {
    const [ hours ] = useHours()
    return (
        <LabeledInput
            iconComponent={showIcon ? ClockFill : null}
            label={label}
        >
            <CheckedMultiSelector
                items={hours}
                title={values.length ? 'Hours' : 'All Hours'}
                onChange={onChange}
                values={values}
                disabled={disabled}
                keyProp='id'
                valueProp='name'
            />
        </LabeledInput>
    )
}

export default ClassHoursMultiSelector